import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Alert,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ColorLegend from "./ColorLegend";
import DataTable from "./DataTable";
import { styles } from "./DataTable.styles";
import ScreenRotationIcon from "@mui/icons-material/ScreenRotation";

const TrademarkReportSummary = ({
  linkedReport,
  linkedReportColumns,
  getDetailedRowColor,
  isMobile,
  showSummaryReport,
  expandAccordian,
  onAccordionChange,
  flipColumns,
}) => {
  if (!showSummaryReport) {
    return (
      <>
        <Typography variant="h6" sx={styles.reportTitle}>
          Trademark Report
        </Typography>
        <Alert severity="info" icon={<ScreenRotationIcon />} sx={styles.alert}>
          Rotate your device to landscape mode to view report table.
        </Alert>
      </>
    );
  }

  return (
    <Accordion
      expanded={expandAccordian}
      onChange={onAccordionChange}
      sx={styles.accordion}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6" sx={styles.accordionTitle}>
          Trademark Report
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        {isMobile ? (
          <Alert
            severity="info"
            icon={<ScreenRotationIcon />}
            sx={styles.alert}
          >
            Rotate your device to landscape mode to view report table.
          </Alert>
        ) : (
          <>
            <ColorLegend
              legendText={["Low Risk", "Medium Risk", "High Risk"]}
              legendColor={[
                styles.lowRiskColor,
                styles.mediumRiskColor,
                styles.highRiskColor,
              ]}
            />
            <DataTable
              columns={linkedReportColumns}
              data={linkedReport}
              getRowColor={getDetailedRowColor}
              isReportData={true}
              sx={styles.dataTable}
              isMobile={isMobile}
              flipColumns={flipColumns}
            />
          </>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default TrademarkReportSummary;
